// extracted by mini-css-extract-plugin
var _1 = "AdminIntegrationView-module__animateUploadProgressBarWidth--nBT1m";
var _2 = "AdminIntegrationView-module__animatedBackground--PlbfW";
var _3 = "AdminIntegrationView-module__buttonGroup--iBByV";
var _4 = "AdminIntegrationView-module__dangerText--fKL9g";
var _5 = "AdminIntegrationView-module__darkerText--n8zyP";
var _6 = "AdminIntegrationView-module__description--Fq1a7";
var _7 = "AdminIntegrationView-module__embeds--VV34S";
var _8 = "AdminIntegrationView-module__embedsDescription--nyGNx";
var _9 = "AdminIntegrationView-module__item--qv5A8";
var _a = "AdminIntegrationView-module__name--IJV_o";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "buttonGroup", _4 as "dangerText", _5 as "darkerText", _6 as "description", _7 as "embeds", _8 as "embedsDescription", _9 as "item", _a as "name" }
